import React from "react";
import classNames from "classnames";

const FacilitiesCard = ({
  isSelected,
  id,
  facilityName,
  isVerified,
  facilityDesc,
  description,
  phone,
  address,
  avatar,
  price,
}) => {
  return (
    <div
      className={classNames(
        "flex gap-x-1 shadow-md rounded-lg cursor-pointer flex-col sm:flex-row",
        { "bg-[#bfdbfe82] border-[#132573] border-2": isSelected },
        { "bg-white border": !isSelected }
      )}
    >
      <div className="p-0.5 max-w-full sm:max-w-[30%] lg:max-w-[23%] flex items-center justify-center">
        <img
          src={avatar || "/images/FacilityPlaceholder.jpg"}
          className="max-h-[50vh] mx-auto lg:max-h-full h-full !rounded-lg object-cover"
          alt="facility"
        />
      </div>
      <div className="flex flex-col w-full p-2">
        <div className="w-full p-2 flex flex-col md:flex-row justify-between">
          <div className="h-full w-full md:w-10/12">
            <div className="text-sm text-midGray">#{id}</div>
            <div className="flex gap-x-2 items-center">
              <div className=" text-midLg font-medium leading-6 flex gap-x-2">
                <div>{facilityName}</div>
              </div>
              <div>
                {isVerified && (
                  <img src="/images/verified.svg" alt="verified icon" />
                )}
              </div>
            </div>
            <div className="text-sm font-normal leading-4.5 py-1 ">
              {description}
            </div>
            <div className="text-sm pt-2.5 text-lightGreen font-normal leading-4.5">
              {facilityDesc}
            </div>
            <div className="text-md pt-2.5 text-lightGreen font-semibold leading-4.5 flex gap-x-2">
              <div>
                <img src="/images/phone.svg" alt="phone icon" />
              </div>
              <div>{phone}</div>
            </div>
            <div className=" text-sm font-normal leading-4.5 my-2">
              <div className="flex gap-x-2 items-center">
                <div>
                  <img src="/images/location.svg" alt="location icon" />
                </div>
                <div className="font-semibold text-sm">{address}</div>
              </div>
            </div>
          </div>
          <div className="h-min md:self-end">
            <div className="text-2xl font-medium leading-6 text-end">
              {`$ ${price}` || "$ 0"}{" "}
              <span className="text-sm text-[#767676]">( USD )</span>
            </div>
            <div className="text-xs leading-4 pt-1">
              includes taxes and fees
            </div>
          </div>
        </div>
        <div className="flex justify-between flex-col md:flex-row">
          <div className="flex gap-x-2">
            <div className="bg-disableGray h-fit p-0.5 px-1 font-bold text-xs rounded-md">
              10
            </div>
            <div className="flex flex-col">
              <div className="text-sm leading-4.5 font-medium">Exceptional</div>
              <div className="text-xs font-normal leading-4.5">416 Views</div>
            </div>
          </div>
          <div className="bg-primary-blue rounded-full flex justify-center items-center py-2 px-3 text-xs font-medium text-white gap-x-2 md:w-fit mt-2 md:mt-0">
            <div>
              <img
                src="/images/selectProvider.svg"
                className="h-4"
                alt="provider icon"
              />
            </div>
            <div>Select This Provider</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FacilitiesCard;
